class EquipmentActivity {
	id = null;
	user_id = null;
	inspection_id = null;
	equipment_activity_note_id = null;
	equipment_id = null;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default EquipmentActivity;
